import React, { Component } from 'react';
import { Route } from 'react-router-dom';

import List from './List';
import EditCatalog from './EditCatalog';
import NewCatalog from './NewCatalog';

class Container extends Component {
  render() {
    return (
      <div id="catalog">
        <Route exact path="/catalog" component={List} />
        <Route exact path="/catalog/new" component={NewCatalog} />
        <Route exact path="/catalog/:id/edit" component={EditCatalog} />
      </div>
    );
  }
}

export default Container;
